import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import ChatStructure from './components/ChatStructure';

ReactDOM.render(
  <React.StrictMode>
    <ChatStructure />
  </React.StrictMode>,
  document.getElementById('root')
);
